export const firstPageComponent = (role: string) => {
  let path: string;
  switch (role) {
    case 'WAREHOUSE_OPERATOR':
      path = '/parcels-warehouse-operator';
      break;
    case 'WAREHOUSE_SUPERVISOR':
      path = '/warehouses';
      break;
    case 'WAREHOUSE_ADMIN':
      path = '/warehouse-admin-orders';
      break;
    default:
      path = '/orders';
  }
  return path;
};
